// extracted by mini-css-extract-plugin
module.exports = {"loader":"ContenLoader_loader__OEyra","spin":"ContenLoader_spin__30RYb"};